module.exports = __webpack_public_path__ + "img/viber image 2019-04-08 , 19.14.54.257087c1.jpg";